/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDtoOfBannerItemDto } from '../../models/paginated-dto-of-banner-item-dto';

export interface GetBanner$Params {
}

export function getBanner(http: HttpClient, rootUrl: string, params?: GetBanner$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfBannerItemDto>> {
  const rb = new RequestBuilder(rootUrl, getBanner.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfBannerItemDto>;
    })
  );
}

getBanner.PATH = '/api/v1/banner';
